import { parse } from "date-fns";

export function parseChartDate(d: { month: number; year: number }): Date {
  return parse(`${d.year}-${d.month.toString().padStart(2, "0")}-01`, "yyyy-MM-dd", new Date());
}
